import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';

export const CarouselCustom = styled(Carousel)`
    & .carousel .control-dots .dot {
        transition: 0.25s;
        background-color: ${(props) => props.theme.greyLink50};
        height: 10px;
        width: 10px;
        box-shadow: none;
        opacity: 1;

        &.selected {
            opacity: 1;
            background-color: ${(props) => props.theme.orange};
            width: 24px;
            height: 10px;
            border-radius: 5px;     
            box-shadow: none;       
        }
    }
`;

export const BannerBox = styled.div`
    display: block;
    & .banner-border{
        border-radius: 16px;
    }
`;
